import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';

const ContatoSchema = Yup.object().shape({
   nome: Yup.string()
     .required('Digite o seu nome'),
   mensagem: Yup.string()
     .required('Digite uma mensagem'),
   email: Yup.string()
     .email('Email inválido')
     .required('Digite seu email'),
});

const ModalSituacao = (props) => {
  
   function submitForm(values, actions) {
      setTimeout(() => {
         alert(JSON.stringify(values, null, 2));
         actions.setSubmitting(false);
      }, 400);
   }

   return(
         <div className="col-md-12">
            <div className="modal__header">
               <h1>Compartilhe uma situação vivenciada por você</h1>
               <h4>(Somente profissionais atuando na linha de frente)</h4>
               <p>Atenção: Apesar de serem permitidas denúncias anônimas, não são aceitos relatos falsos.</p>
            </div>
          <Formik
                  
            initialValues={{ 
               nome: '', 
               email: '', 
               mensagem: '' 
            }}

            validationSchema={ContatoSchema}

            onSubmit={(values, { setSubmitting }) => submitForm(values, { setSubmitting })}
         >
            {({
               values,
               errors,
               touched,
               handleChange,
               handleBlur,
               handleSubmit,
               isSubmitting,
            }) => (
               <form className="form" onSubmit={handleSubmit}>
                  <div className="row">
                     
                     <div className="col-md-12">
                        <div class="form-group">
                           <label className="form-label" htmlFor="vulnerabilidade">Tipo de vulnerabilidade presenciada por você: <span className="form-required">*</span></label>
                           <select
                              className={`form-input ${ errors.nome && touched.nome ? 'is-invalid' : '' }`}
                              name="vulnerabilidade"
                              placeholder="Tipo de vulnerabilidade presenciada por você"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.nome}
                           >
                              <option value="1">Não utilização de equipamento de proteção individual (EPI) e/ou uso inadequado</option>
                              <option value="2">Sem condições de segurança e/ou orientações na retirada de paramentação</option>
                              <option value="3">Instalações sem adequação para evitar contaminação</option>
                              <option value="4">Profissionais sem apoio e/ou condições psicológicas para trabalhar</option>
                              <option value="5">Profissional não teve dispensa do trabalho ao apresentar sintomas compatíveis</option>
                              <option value="6">Profissional não teve dispensa do trabalho e faz parte do grupo de risco para evolução como caso grave</option>
                              <option value="7">Profissional não teve dispensa do trabalho e é contato domiciliar de pessoa sintomática</option>
                              <option value="6">Fui acompanhante de paciente com COVID-19 e não tive acesso a equipamento de proteção individual (EPI)</option>
                              <option value="9">Para ter notícias do meu familiar enfrentei filas e aglomerações em locais de atendimento aos pacientes</option>
                              <option value="10">Outro</option>
                              <option value="11">Prefiro não dizer</option>
                           </select>
                        </div>
                     </div>

                     <div className="col-md-12">
                        <div class="form-group">
                           <label className="form-label" htmlFor="descreva">Descreva: <span className="form-required">*</span></label>
                           <textarea
                              className={`form-input ${ errors.descreva && touched.descreva ? 'is-invalid' : '' }`}
                              placeholder="Descreva uma situação"
                              type="text"
                              name="descreva"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.messagem}
                           ></textarea>
                        </div>
                     </div>

                     <div className="col-md-6">
                        <div className="form-group">
                           <label className="form-label" htmlFor="data">Data: <span className="form-required">*</span></label>
                           <input
                              className={`form-input ${ errors.data && touched.data ? 'is-invalid' : '' }`}
                              type="text"
                              name="data"
                              placeholder="dd/mm/yy"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.nome}
                           />
                        </div>
                     </div>

                     <div className="col-md-6">
                        <div className="form-group">
                           <label className="form-label" htmlFor="data">Período: <span className="form-required">*</span></label>
                           <select
                              className={`form-input ${ errors.nome && touched.nome ? 'is-invalid' : '' }`}
                              name="vulnerabilidade"
                              placeholder="Periodo"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.nome}
                           >
                              <option value="manha">Manhã</option>
                              <option value="tarde">Tarde</option>
                              <option value="noite">Noite</option>
                           </select>
                        </div>
                     </div>

                     <div class="col-md-6">
                        <div className="form-group">
                           <label className="form-label" htmlFor="data">Idade:</label>
                           <input
                              className={`form-input ${ errors.idade && touched.idade ? 'is-invalid' : '' }`}
                              type="number"
                              name="idade"
                              placeholder="Idade"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.nome}
                           />
                        </div>
                     </div>

                     <div className="col-md-6">
                        <div class="form-group">
                           <label className="form-label" htmlFor="renda">Renda:</label>
                           <select
                              className={`form-input ${ errors.renda && touched.renda ? 'is-invalid' : '' }`}
                              name="renda"
                              placeholder="Renda"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.renda}
                           >
                              <option value="1">1 salário mínimo</option>
                              <option value="2">De 3 a 5 salários mínimos</option>
                              <option value="3">De 5 a 10 salários mínimos</option>
                              <option value="4">De 10 a 20 salários mínimos</option>
                              <option value="5">Mais de 20 salários mínimos</option>
                              <option value="6">Prefiro não dizer</option>
                           </select>
                        </div>
                     </div>

                     <div className="col-md-6">
                        <div class="form-group">
                           <label className="form-label" htmlFor="escolaridade">Escolaridade:</label>
                           <select
                              className={`form-input ${ errors.escolaridade && touched.escolaridade ? 'is-invalid' : '' }`}
                              name="escolaridade"
                              placeholder="Escolaridade"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.escolaridade}
                           >
                              <option value="1">Não alfabetizado</option>
                              <option value="2">Somente alfabetizado</option>
                              <option value="3">Ensino Fundamental incompleto</option>
                              <option value="4">Ensino Fundamental completo</option>
                              <option value="5">Ensino Médio incompleto</option>
                              <option value="6">Ensino Médio completo</option>
                              <option value="7">Ensino Superior incompleto</option>
                              <option value="8">Ensino Superior completo</option>
                              <option value="9">Superior</option>
                              <option value="10">Mestrado</option>
                              <option value="11">Doutorado</option>
                              <option value="12">Não sabe</option>
                              <option value="13">Prefiro não dizer</option>
                           </select>
                        </div>
                     </div>

                     <div className="col-md-6">
                        <div class="form-group">
                           <label className="form-label" htmlFor="categoria-profissional">Categoria Profissional:</label>
                           <select
                              className={`form-input ${ errors.escolaridade && touched.escolaridade ? 'is-invalid' : '' }`}
                              name="categoria-profissional"
                              placeholder="Categoria Profissional"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.escolaridade}
                           >
                              <option value="1">Assistentes Sociais</option>
                              <option value="2">Biólogos</option>
                              <option value="3">Biomédicos</option>
                              <option value="4">Profissionais de Educação Física</option>
                              <option value="5">Enfermeiros</option>
                              <option value="6">Farmacêuticos</option>
                              <option value="7">Fonoaudiólogos</option>
                              <option value="8">Ensino Superior completo</option>
                              <option value="9">Médicos</option>
                              <option value="10">Médicos Veterinários</option>
                              <option value="11">Nutricionistas</option>
                              <option value="12">Odontólogos</option>
                              <option value="13">Psicólogos</option>
                              <option value="14">Terapeutas Ocupacionais</option>
                              <option value="15">Sanitarista (Bacharelado/Graduação)</option>
                              <option value="16">Técnico de Enfermagem</option>
                              <option value="17">Médicos Veterinários</option>
                              <option value="18">Auxiliar de Enfermagem</option>
                              <option value="19">Agente comunitário de saúde</option>
                              <option value="20">Agente de vigilância em saúde/endemias</option>
                              <option value="21">Recepcionista</option>
                              <option value="22">Maqueiro</option>
                              <option value="23">Segurança</option>
                              <option value="24">Serviços gerais</option>
                              <option value="25">Outro</option>
                              <option value="26">Prefiro não dizer</option>
                           </select>
                        </div>
                     </div>

                     <div className="col-md-6">
                        <div class="form-group">
                           <label className="form-label" htmlFor="sexo">Sexo:</label>
                           <select
                              className={`form-input ${ errors.sexo && touched.sexo ? 'is-invalid' : '' }`}
                              name="sexo"
                              placeholder="Sexo"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.sexo}
                           >
                              <option value="1">Masculino</option>
                              <option value="2">Feminino</option>
                              <option value="3">Indefinido</option>
                           </select>
                        </div>
                     </div>

                     <div className="col-md-6">
                        <div class="form-group">
                           <label className="form-label" htmlFor="sexo">Cor:</label>
                           <select
                              className={`form-input ${ errors.sexo && touched.sexo ? 'is-invalid' : '' }`}
                              name="sexo"
                              placeholder="Cor"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.sexo}
                           >
                              <option value="1">Branco</option>
                              <option value="2">Preto</option>
                              <option value="3">Pardo</option>
                              <option value="2">Indígena</option>
                              <option value="3">Amarelo</option>
                              <option value="2">Prefiro não dizer</option>
                           </select>
                        </div>
                     </div>   

                     <div class="col-md-12">
                        <div className="form-group">
                           <label className="form-label" htmlFor="data">Nome:</label>
                           <input
                              className={`form-input ${ errors.nome && touched.nome ? 'is-invalid' : '' }`}
                              type="text"
                              name="Nome"
                              placeholder="Nome"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.nome}
                           />
                        </div>
                     </div> 


                  </div>
                  <p>Não divulgaremos seus dados pessoais</p>
                  <button className="button button--primary" type="submit" disabled={isSubmitting}>Enviar</button>
               </form>
            )}
         </Formik>
      </div>
   )
}

export default ModalSituacao;
